import React from 'react';
import TicketPreviewPage from './TicketPreviewPage';

export default function index() {
  return <TicketPreviewPage />;
}
